<template>
    <div class='bottom-footer-container'>
        <div class='a'>
        </div>
        <div class="details">
            <div class="detail-1">© Saturday Kitchen {{year}}</div>
            <div class="detail-2">By shopping at Saturday Kitchen you confirm you are over 18.</div>
            <div class="detail-2">You may be asked to provide ID on receipt of delivery.</div>
        </div>
        <div class="bottom-links">
            <div @click="onClickLink('terms-of-use')"><a class="footer-link">Terms of Use</a></div>
            <div @click="onClickLink('privacy-cookies')"><a class="footer-link">Privacy Policy</a></div>
            <div @click="onClickLink('terms-conditions')"><a class="footer-link">Terms & Conditions</a></div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            year: new Date().getFullYear()
        }
    },
    methods: {
        onClickLink(page) {
            this.$router.push(`/${page}`);
        }
    }
}
</script>

<style lang="scss" scoped>
.bottom-footer-container{
    display: flex;
    justify-content: space-between;
    color: var(--black);

    @media(max-width: 1500px){
        
    }

    @media(max-width: 768px){
        justify-content: center;
        gap: 20px;  
        flex-direction: column;
    }
}

.a{
    flex-basis: 33%;
     @media(max-width: 1600px){
        display: none;
    }
}

.bottom-links{
    display: flex;
    gap: 15px;
    flex-basis: 33%;
    justify-content: flex-end;

    @media(max-width: 1600px){
        flex-basis: 50%;
    }

    @media(max-width: 768px){
        flex-basis: 100%;
        justify-content: center;
        text-align: center;
    }
}
.details{
    text-align: center;
    color: black;
    flex-basis: 33%;

    @media(max-width: 1600px){
        flex-basis: 50%;
    }

    @media(max-width: 768px){
        flex-basis: 100%;
    }
}

.detail-1{
    font-size: 0.857rem;
    margin-bottom: 7px;
}
.detail-2{
    font-size: 0.725rem;
    font-weight: 300;
}
.footer-link{
    font-weight: 600;
}
</style>